module.exports = __webpack_public_path__ + "static/media/left-arrow.a803b635.svg";